import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  trackPageView,
  getPageTitle,
  trackFeatureTransition,
  trackFeatureDuration,
  ROUTE_FEATURE_MAP,
} from '../analytics';

export default function usePageTracking() {
  const location = useLocation();
  const previousPathname = useRef(location.pathname);
  const previousFeature = useRef(ROUTE_FEATURE_MAP[location.pathname] || null);
  const featureEntryTime = useRef(Date.now());

  useEffect(() => {
    const pathname = location.pathname;

    // Avoid duplicate tracking on initial render
    if (pathname === previousPathname.current) return;

    // Track page view for the new route
    trackPageView(pathname, getPageTitle(pathname));

    // Feature transition and duration tracking
    const currentFeature = ROUTE_FEATURE_MAP[pathname] || null;
    const prevFeature = previousFeature.current;

    if (prevFeature && prevFeature !== currentFeature) {
      const durationSeconds = Math.round(
        (Date.now() - featureEntryTime.current) / 1000
      );
      if (durationSeconds > 0) {
        trackFeatureDuration(prevFeature, durationSeconds);
      }
      if (currentFeature) {
        trackFeatureTransition(prevFeature, currentFeature);
      }
    }

    // Update refs
    previousPathname.current = pathname;
    previousFeature.current = currentFeature;
    featureEntryTime.current = Date.now();
  }, [location.pathname]);
}
